// extracted by mini-css-extract-plugin
module.exports = {"menu":"List__menu___1aasu","list":"List__list___2Aead"};